module.exports = __webpack_public_path__ + "img/warning-6.235bee9c.png";